import React from 'react';
import { Link } from 'react-router-dom';
import { Circle } from 'lucide-react';
import './PartsolGroup.css';

const PartsolGroup = () => {
  const timeline = [
    {
      year: '1990-2007',
      title: 'Algorithm Development',
      description: 'Lt. Col. Darryl Williams develops core algorithms in the U.S. Air Force and expands them over 15 years to deconstruct complex supply networks with a focus on risk, intelligence, and mission-critical insights.'
    },
    {
      year: '2007',
      title: 'PSI Founded',
      description: 'Dr. Williams launches Partnership Solutions International (PSI) to apply it to government and commercial intelligence challenges.'
    },
    {
      year: '2007-2020',
      title: 'Consulting Services',
      description: 'PSI provides consulting services to agencies and corporations on projects from missile defense supply chain analysis to corporate fraud and insider threat detection.'
    },
    {
      year: '2020',
      title: 'Pandemic Response',
      description: 'PSI plays a leading role in helping institutions respond to pandemic-driven global supply chain breakdowns.'
    },
    {
      year: '2024',
      title: 'Rebrand & Seed Funding',
      description: "PSI rebrands as Partsol and raises seed funding to accelerate product development, including for its new SaaS offering, and go-to-market plans."
    },
    {
      year: '2025',
      title: 'Atai Launch',
      description: 'Beta version of Flagship SaaS product, Atai (Absolute Truth AI) launched. Partsol Futures launched as an R&D Research Lab; introduction of game-changing AI Stem Cells.'
    },
    {
      year: '2026+',
      title: 'The Future',
      description: 'First Proof of using AI Stem Cells for detecting economic relationships between two unassociated variables; Atai 2.0 expected to be launched into GA in Q1\'26; Partsol Defense established as government-sector business unit.'
    }
  ];

  const organizations = [
    {
      name: 'Partsol Futures',
      location: 'Tampa, FL & Nashville, TN',
      description: 'Dually headquartered in Tampa, FL and Nashville, TN, Partsol Futures is a research and innovation lab focused on accelerating breakthrough applications of Partsol\'s unique AGI capabilities. Specific areas of focus include national security, proprietary trading/financial services, smart infrastructure, life sciences & healthcare, and advanced/heavy manufacturing, among others.',
      image: '/graphics/3.png'
    },
    {
      name: 'Partsol Defense',
      location: 'Tampa, FL',
      description: 'Headquartered in Tampa, FL, Partsol Defense is the dedicated commercial arm for Partsol\'s defense business. The group is focused exclusively on government agencies and is responsible for providing innovative solutions (software and services) for use cases such as intelligence analysis, identity forensics, supply chain forensics, and offensive security, among others.',
      image: '/graphics/1.png'
    },
  ];

  return (
    <div className="group-page">
      <section className="group-hero">
        <div className="group-hero-content">
          <p className="group-hero-label">Partsol Group</p>
          <h1 className="group-hero-title">Our Organizations</h1>
          <p className="group-hero-subtitle">
            The Partsol Family of Companies
          </p>
        </div>
      </section>

      <section className="group-organizations">
        <div className="organizations-container">
          <div className="organizations-grid">
            {organizations.map((org, index) => (
              <div key={index} className="organization-card">
                <div className="org-image-wrapper">
                  <img src={org.image} alt={org.name} className="org-image" />
                </div>
                <h3 className="org-name">{org.name}</h3>
                <p className="org-location">{org.location}</p>
                <p className="org-description">{org.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="group-journey">
        <div className="journey-container">
          <p className="journey-label">Our Story</p>
          <h2 className="journey-title">Our Journey to Absolute Truth</h2>
          <p className="journey-subtitle">
            Discover the story of how Partsol is transforming enterprise decision-making
            through Cognitive AI innovation.
          </p>
        </div>
      </section>

      <section className="group-timeline">
        <div className="timeline-container">
          <p className="timeline-label">Partsol Timeline</p>
          <h2 className="timeline-title">Building the Future, One Milestone at a Time</h2>

          <div className="timeline">
            {timeline.map((item, index) => (
              <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-content">
                  <span className="timeline-year">{item.year}</span>
                  <h3 className="timeline-item-title">{item.title}</h3>
                  <p className="timeline-description">{item.description}</p>
                </div>
                <div className="timeline-marker">
                  <Circle size={16} fill="#AE8735" color="#AE8735" />
                </div>
              </div>
            ))}
            <div className="timeline-line"></div>
          </div>
        </div>
      </section>

      <section className="group-cta">
        <div className="cta-container">
          <h2>Be Part of Our Story</h2>
          <p>Join us in building the future of Cognitive AI and truth discovery.</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartsolGroup;
